import {
  BEST_STRATEGIES,
  AVERAGE_STRATEGIES,
  WORST_STRATEGIES,
  NO_DATA,
  GREEN,
  YELLOW,
  RED
} from '../constants';

export const transposeStrategies = (strategies, obj = {}, index = 0) => {

  if(strategies.length === index){
    return obj;
  }

  let strategy = strategies[index];

  Object.keys(strategy).forEach(function(key,i) {
    if(!obj.hasOwnProperty(key)){
      obj[key] = [strategy[key]];
    }else{
      obj[key].push(strategy[key])
    }
  });
  return transposeStrategies(strategies,obj,index+1); // Recursion
}

export const getStrategyText = (strategy) => {
  const isSmallScreen =  window.matchMedia("(max-width: 600px)").matches;

  switch (strategy) {
    case BEST_STRATEGIES:
      return isSmallScreen ? ">90%" : ">90% effekt";
    case AVERAGE_STRATEGIES:
      return isSmallScreen ? "70-90%" : "70-90% effekt";
    case WORST_STRATEGIES:
      return isSmallScreen ? "40-70%" : "40-70% effekt";
    case NO_DATA:
      return isSmallScreen ? "<40%/I.U." : "<40% effekt/ej uppgift";
    default:
      return "";
  }
}
export const getCompareColor = (strategy) => {
  switch (strategy) {
    case BEST_STRATEGIES:
      return GREEN
    case AVERAGE_STRATEGIES:
      return YELLOW
    case WORST_STRATEGIES:
      return RED
    case NO_DATA:
      return "#FFF"
    default:
      return "#FFF"
  }
}

export const getStrategyColor = (strategy) => {
  switch (strategy) {
    case BEST_STRATEGIES:
      return GREEN
    case AVERAGE_STRATEGIES:
      return YELLOW
    case WORST_STRATEGIES:
      return RED
    case NO_DATA:
      return "#FFF"
    default:
      return "#FFF"
  }
}
